import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FaIcon = _resolveComponent("FaIcon")!
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!

  return (_ctx.linkType !== 'button')
    ? (_openBlock(), _createBlock(_component_IoRouterLink, {
        key: 0,
        "link-url": _ctx.buttonUrl,
        class: _normalizeClass(["io-button btn", _ctx.classes]),
        "link-target": _ctx.buttonTarget
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FaIcon, { icon: _ctx.icon }, null, 8, ["icon"]),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["link-url", "class", "link-target"]))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: _normalizeClass(["io-button btn", _ctx.classes])
      }, [
        (_ctx.icon)
          ? (_openBlock(), _createBlock(_component_FaIcon, {
              key: 0,
              icon: _ctx.icon
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 2))
}